// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: z5fIHof2db

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import CloseButton from "../../CloseButton"; // plasmic-import: S8350pIpoy/component
import TextInput from "../../TextInput"; // plasmic-import: 5gQXQ5PIHOg/component

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicHubCreation.module.css"; // plasmic-import: z5fIHof2db/css

import SearchsvgIcon from "./icons/PlasmicIcon__Searchsvg"; // plasmic-import: rQjkwIrrF-2/icon
import IconsCloseIcon from "./icons/PlasmicIcon__IconsClose"; // plasmic-import: -dI1oop3LS/icon
import ArrowEnterIcon from "./icons/PlasmicIcon__ArrowEnter"; // plasmic-import: IiOos6vDQ/icon

createPlasmicElementProxy;

export type PlasmicHubCreation__VariantMembers = {
  createEmptyHub: "createEmptyHub";
};
export type PlasmicHubCreation__VariantsArgs = {
  createEmptyHub?: SingleBooleanChoiceArg<"createEmptyHub">;
};
type VariantPropType = keyof PlasmicHubCreation__VariantsArgs;
export const PlasmicHubCreation__VariantProps = new Array<VariantPropType>(
  "createEmptyHub"
);

export type PlasmicHubCreation__ArgsType = {};
type ArgPropType = keyof PlasmicHubCreation__ArgsType;
export const PlasmicHubCreation__ArgProps = new Array<ArgPropType>();

export type PlasmicHubCreation__OverridesType = {
  root?: p.Flex<"div">;
  closeBtn?: p.Flex<typeof CloseButton>;
  freeBox?: p.Flex<"div">;
  createEmptyHubBtn?: p.Flex<"button">;
  createSourceBasedHubBtn?: p.Flex<"button">;
  createInterestBasedHubBtn?: p.Flex<"button">;
  createEmptyHubForm?: p.Flex<"form">;
  input?: p.Flex<typeof TextInput>;
  createEmptyHubFormSubmitBtn?: p.Flex<"button">;
  text?: p.Flex<"div">;
  svg?: p.Flex<"svg">;
};

export interface DefaultHubCreationProps {
  createEmptyHub?: SingleBooleanChoiceArg<"createEmptyHub">;
  className?: string;
}

const $$ = {};

function PlasmicHubCreation__RenderFunc(props: {
  variants: PlasmicHubCreation__VariantsArgs;
  args: PlasmicHubCreation__ArgsType;
  overrides: PlasmicHubCreation__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "createEmptyHub",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.createEmptyHub
      },
      {
        path: "input.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <p.Stack
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.rootcreateEmptyHub]: hasVariant(
            $state,
            "createEmptyHub",
            "createEmptyHub"
          )
        }
      )}
    >
      <CloseButton
        data-plasmic-name={"closeBtn"}
        data-plasmic-override={overrides.closeBtn}
        className={classNames("__wab_instance", sty.closeBtn)}
      />

      <p.Stack
        as={"div"}
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        hasGap={true}
        className={classNames(projectcss.all, sty.freeBox, {
          [sty.freeBoxcreateEmptyHub]: hasVariant(
            $state,
            "createEmptyHub",
            "createEmptyHub"
          )
        })}
      >
        <button
          data-plasmic-name={"createEmptyHubBtn"}
          data-plasmic-override={overrides.createEmptyHubBtn}
          className={classNames(
            projectcss.all,
            projectcss.button,
            projectcss.__wab_text,
            sty.createEmptyHubBtn
          )}
          disabled={false}
          ref={ref => {
            $refs["createEmptyHubBtn"] = ref;
          }}
        >
          {"Create Empty Hub"}
        </button>
        <button
          data-plasmic-name={"createSourceBasedHubBtn"}
          data-plasmic-override={overrides.createSourceBasedHubBtn}
          className={classNames(
            projectcss.all,
            projectcss.button,
            projectcss.__wab_text,
            sty.createSourceBasedHubBtn
          )}
          ref={ref => {
            $refs["createSourceBasedHubBtn"] = ref;
          }}
        >
          {"Create Source Based Hub"}
        </button>
        <button
          data-plasmic-name={"createInterestBasedHubBtn"}
          data-plasmic-override={overrides.createInterestBasedHubBtn}
          className={classNames(
            projectcss.all,
            projectcss.button,
            projectcss.__wab_text,
            sty.createInterestBasedHubBtn
          )}
          ref={ref => {
            $refs["createInterestBasedHubBtn"] = ref;
          }}
        >
          {"Create Interest Based Hub"}
        </button>
      </p.Stack>
      <form
        data-plasmic-name={"createEmptyHubForm"}
        data-plasmic-override={overrides.createEmptyHubForm}
        className={classNames(projectcss.all, sty.createEmptyHubForm, {
          [sty.createEmptyHubFormcreateEmptyHub]: hasVariant(
            $state,
            "createEmptyHub",
            "createEmptyHub"
          )
        })}
      >
        <TextInput
          data-plasmic-name={"input"}
          data-plasmic-override={overrides.input}
          aria-label={"name"}
          className={classNames("__wab_instance", sty.input, {
            [sty.inputcreateEmptyHub]: hasVariant(
              $state,
              "createEmptyHub",
              "createEmptyHub"
            )
          })}
          context={"hubCreationModal"}
          onChange={(...eventArgs) => {
            p.generateStateOnChangeProp($state, ["input", "value"])(
              (e => e.target?.value).apply(null, eventArgs)
            );
          }}
          placeholder={"Enter your Hub Name"}
          required={true}
          type={"text"}
          value={p.generateStateValueProp($state, ["input", "value"]) ?? ""}
        />

        <p.Stack
          as={"button"}
          data-plasmic-name={"createEmptyHubFormSubmitBtn"}
          data-plasmic-override={overrides.createEmptyHubFormSubmitBtn}
          hasGap={true}
          className={classNames(
            projectcss.all,
            projectcss.button,
            sty.createEmptyHubFormSubmitBtn,
            {
              [sty.createEmptyHubFormSubmitBtncreateEmptyHub]: hasVariant(
                $state,
                "createEmptyHub",
                "createEmptyHub"
              )
            }
          )}
          disabled={
            hasVariant($state, "createEmptyHub", "createEmptyHub")
              ? false
              : undefined
          }
          ref={ref => {
            $refs["createEmptyHubFormSubmitBtn"] = ref;
          }}
          type={"submit"}
        >
          <div
            data-plasmic-name={"text"}
            data-plasmic-override={overrides.text}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text,
              {
                [sty.textcreateEmptyHub]: hasVariant(
                  $state,
                  "createEmptyHub",
                  "createEmptyHub"
                )
              }
            )}
          >
            {"Create"}
          </div>
          <ArrowEnterIcon
            data-plasmic-name={"svg"}
            data-plasmic-override={overrides.svg}
            className={classNames(projectcss.all, sty.svg, {
              [sty.svgcreateEmptyHub]: hasVariant(
                $state,
                "createEmptyHub",
                "createEmptyHub"
              )
            })}
            role={"img"}
          />
        </p.Stack>
      </form>
    </p.Stack>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "closeBtn",
    "freeBox",
    "createEmptyHubBtn",
    "createSourceBasedHubBtn",
    "createInterestBasedHubBtn",
    "createEmptyHubForm",
    "input",
    "createEmptyHubFormSubmitBtn",
    "text",
    "svg"
  ],
  closeBtn: ["closeBtn"],
  freeBox: [
    "freeBox",
    "createEmptyHubBtn",
    "createSourceBasedHubBtn",
    "createInterestBasedHubBtn"
  ],
  createEmptyHubBtn: ["createEmptyHubBtn"],
  createSourceBasedHubBtn: ["createSourceBasedHubBtn"],
  createInterestBasedHubBtn: ["createInterestBasedHubBtn"],
  createEmptyHubForm: [
    "createEmptyHubForm",
    "input",
    "createEmptyHubFormSubmitBtn",
    "text",
    "svg"
  ],
  input: ["input"],
  createEmptyHubFormSubmitBtn: ["createEmptyHubFormSubmitBtn", "text", "svg"],
  text: ["text"],
  svg: ["svg"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  closeBtn: typeof CloseButton;
  freeBox: "div";
  createEmptyHubBtn: "button";
  createSourceBasedHubBtn: "button";
  createInterestBasedHubBtn: "button";
  createEmptyHubForm: "form";
  input: typeof TextInput;
  createEmptyHubFormSubmitBtn: "button";
  text: "div";
  svg: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHubCreation__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHubCreation__VariantsArgs;
    args?: PlasmicHubCreation__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicHubCreation__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicHubCreation__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHubCreation__ArgProps,
          internalVariantPropNames: PlasmicHubCreation__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHubCreation__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHubCreation";
  } else {
    func.displayName = `PlasmicHubCreation.${nodeName}`;
  }
  return func;
}

export const PlasmicHubCreation = Object.assign(
  // Top-level PlasmicHubCreation renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    closeBtn: makeNodeComponent("closeBtn"),
    freeBox: makeNodeComponent("freeBox"),
    createEmptyHubBtn: makeNodeComponent("createEmptyHubBtn"),
    createSourceBasedHubBtn: makeNodeComponent("createSourceBasedHubBtn"),
    createInterestBasedHubBtn: makeNodeComponent("createInterestBasedHubBtn"),
    createEmptyHubForm: makeNodeComponent("createEmptyHubForm"),
    input: makeNodeComponent("input"),
    createEmptyHubFormSubmitBtn: makeNodeComponent(
      "createEmptyHubFormSubmitBtn"
    ),
    text: makeNodeComponent("text"),
    svg: makeNodeComponent("svg"),

    // Metadata about props expected for PlasmicHubCreation
    internalVariantProps: PlasmicHubCreation__VariantProps,
    internalArgProps: PlasmicHubCreation__ArgProps
  }
);

export default PlasmicHubCreation;
/* prettier-ignore-end */
